var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.75 9.792a3.332 3.332 0 1 0 0-6.667 3.332 3.332 0 1 0 0 6.667Zm0-5c.917 0 1.667.75 1.667 1.666 0 .917-.75 1.667-1.667 1.667s-1.667-.75-1.667-1.667c0-.916.75-1.666 1.667-1.666Zm-5 10c.167-.525 2.142-1.4 4.133-1.617l1.7-1.667a7.792 7.792 0 0 0-.833-.05c-2.225 0-6.667 1.117-6.667 3.334v1.666h7.5l-1.666-1.666H3.75Zm13-4.584-4.275 4.309-1.725-1.734-1.167 1.175 2.892 2.917 5.442-5.492-1.167-1.175Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheck);
export default __webpack_public_path__ + "static/media/UserCheck.05004b9376d500d5ef5972983ba1a196.svg";
export { ForwardRef as ReactComponent };